import { buildCollection, buildProperty } from "@firecms/core";
import {
    optionKeyEnumValues,
    quizDifficultyEnumValues,
    quizStatusEnumValues,
} from "./shared/enums";

export type UserQuiz = {
    id?: string;
    title?: string;
    subject?: string;
    topic?: string;
    difficulty?: keyof typeof quizDifficultyEnumValues;
    status?: keyof typeof quizStatusEnumValues;
    createdAt?: Date;
    completedAt?: Date;
    totalQuestions?: number;
    correctCount?: number;
    incorrectCount?: number;
    emptyCount?: number;
    questions?: unknown[];
};

/**
 * users/{uid}/quizzes — kullanıcı quizleri. Salt okunur.
 */
export const userQuizzesCollection = buildCollection<UserQuiz>({
    id: "quizzes",
    name: "Quizler",
    singularName: "Quiz",
    path: "quizzes",
    icon: "quiz",
    titleProperty: "title",
    initialSort: ["createdAt", "desc"],
    permissions: {
        read: true,
        create: false,
        edit: false,
        delete: false,
    },
    properties: {
        title: buildProperty({
            name: "Başlık",
            dataType: "string",
            readOnly: true,
        }),
        subject: buildProperty({
            name: "Ders",
            dataType: "string",
            readOnly: true,
        }),
        topic: buildProperty({
            name: "Konu",
            dataType: "string",
            readOnly: true,
        }),
        difficulty: buildProperty({
            name: "Zorluk",
            dataType: "string",
            enumValues: quizDifficultyEnumValues,
            readOnly: true,
        }),
        status: buildProperty({
            name: "Durum",
            dataType: "string",
            enumValues: quizStatusEnumValues,
            readOnly: true,
        }),
        createdAt: buildProperty({
            name: "Oluşturulma",
            dataType: "date",
            mode: "date_time",
            readOnly: true,
        }),
        completedAt: buildProperty({
            name: "Tamamlanma",
            dataType: "date",
            mode: "date_time",
            readOnly: true,
        }),
        totalQuestions: buildProperty({
            name: "Soru sayısı",
            dataType: "number",
            readOnly: true,
        }),
        correctCount: buildProperty({
            name: "Doğru",
            dataType: "number",
            readOnly: true,
        }),
        incorrectCount: buildProperty({
            name: "Yanlış",
            dataType: "number",
            readOnly: true,
        }),
        emptyCount: buildProperty({
            name: "Boş",
            dataType: "number",
            readOnly: true,
        }),
        id: buildProperty({
            name: "Quiz ID",
            dataType: "string",
            readOnly: true,
        }),
        questions: buildProperty({
            name: "Sorular",
            dataType: "array",
            readOnly: true,
            of: {
                dataType: "map",
                properties: {
                    questionText: buildProperty({
                        name: "Soru",
                        dataType: "string",
                        multiline: true,
                        readOnly: true,
                    }),
                    options: buildProperty({
                        name: "Şıklar",
                        dataType: "map",
                        keyValue: true,
                        readOnly: true,
                    }),
                    correctAnswer: buildProperty({
                        name: "Doğru",
                        dataType: "string",
                        enumValues: optionKeyEnumValues,
                        readOnly: true,
                    }),
                    userAnswer: buildProperty({
                        name: "Kullanıcı cevabı",
                        dataType: "string",
                        enumValues: optionKeyEnumValues,
                        readOnly: true,
                    }),
                    isCorrect: buildProperty({
                        name: "Doğru mu",
                        dataType: "boolean",
                        readOnly: true,
                    }),
                    explanation: buildProperty({
                        name: "Açıklama",
                        dataType: "array",
                        readOnly: true,
                        of: {
                            dataType: "map",
                            properties: {
                                type: buildProperty({
                                    name: "Tip",
                                    dataType: "string",
                                    readOnly: true,
                                }),
                                title: buildProperty({
                                    name: "Başlık",
                                    dataType: "string",
                                    readOnly: true,
                                }),
                                content: buildProperty({
                                    name: "İçerik",
                                    dataType: "string",
                                    multiline: true,
                                    readOnly: true,
                                }),
                            },
                        },
                    }),
                },
            },
        }),
    },
});
